// THIS IS THE DEFAULT VALUE YOU CAN CHANGE IF YOU WANT

import { MOBILE_BREAKPOINT } from "../constants";

const breakpoints = {
  values: {
    xs: 0,
    sm: MOBILE_BREAKPOINT,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export default breakpoints;
